import { render, staticRenderFns } from "./preFacturas.vue?vue&type=template&id=47d6629e"
import script from "./preFacturas.vue?vue&type=script&lang=js"
export * from "./preFacturas.vue?vue&type=script&lang=js"
import style0 from "./preFacturas.vue?vue&type=style&index=0&id=47d6629e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports